import { tsv } from "@faire/slate/lib/tsv";
import { Chevron as ChevronIcon } from "@faire/web/slate/icons/foundation/Chevron";
import React from "react";

type IProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "children">;

export const AccordionChevron = ({ className, ...props }: IProps) => {
  return (
    <span className={chevronStyle.cls({ className })} {...props}>
      <ChevronIcon direction="down" />
    </span>
  );
};

const chevronStyle = tsv({
  base: "fs-accordion__chevron",
});
